import { FC } from 'react'
import TableBodyComponent from './table-body'

interface MiniTableComponentProps<TData = any> {
  data: TData[];
  loading?: boolean;
  renderColumns?: FC<TData>;
  renderItem?: FC<TData>;
  renderLoader?: FC;
}

const MiniTableComponent: FC<MiniTableComponentProps> = ({ loading, renderColumns, renderItem, renderLoader, data }) => {

  return (
    <div className="">
      <TableBodyComponent
        data={data}
        loading={loading}
        // renderColumns={renderColumns}
        renderLoader={renderLoader}
        renderItem={renderItem} columns={[]} showHeader={false} />

    </div>
  )
}

export default MiniTableComponent